<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'employee/index' }">
                                Pegawai BTA
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Pegawai BTA
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row mb-4 align-items-end">
                        <div class="col-xl-3 col-lg-4 p-1" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager))">
                            <label class="text-muted d-lg-flex d-none">Filter Cabang</label>
                            <select v-model="form.search.branchID" class="form-control form-control-sm">
                                <option value="">Semua Cabang...</option>
                                <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-lg-4 p-1">
                            <label class="text-muted d-lg-flex d-none">Search</label>
                            <input v-model="form.search.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-xl col-lg-auto col p-1">
                            <button type="submit" class="btn btn-danger btn-sm px-3 mr-2">
                                Search
                            </button>
                            <button type="button" class="btn btn-sm btn-link" v-on:click="filterShow = !filterShow">
                                Column Filtering
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-3" v-on:click="download">
                                Download
                            </button>
                        </div>
                        <div class="col-xl-auto col-lg-12 col-auto p-1 text-right" v-if="roleElligibleModified()">
                            <button v-b-tooltip.hover title="Upload data pegawai sesuai dengan template" type="button" class="btn btn-outline-danger btn-sm px-3" v-on:click="modalShow = true">
                                Upload Data
                            </button>
                            <router-link v-b-tooltip.hover title="Menambahkan data pegawai baru" v-bind:to="{name: 'employee/add'}" class="btn btn-danger btn-sm px-3 ml-2">
                                Create Pegawai
                            </router-link>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="row mt-4" v-if="filterShow">
                            <div class="col">
                                <h4 class="text-danger mb-4">Pilih atribute yang ingin ditampilkan</h4>
                                <div class="row">
                                    <div class="col-12">
                                        <!--Section 1--> 
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Profil Pegawai
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.username" type="checkbox" class="custom-control-input" id="filter-username" />
                                                        <label class="custom-control-label" for="filter-username">Username</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.name" type="checkbox" class="custom-control-input" id="filter-name" />
                                                        <label class="custom-control-label" for="filter-name">Nama Lengkap</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.shortname" type="checkbox" class="custom-control-input" id="filter-shortname" />
                                                        <label class="custom-control-label" for="filter-shortname">Nama Panggilan</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.initial" type="checkbox" class="custom-control-input" id="filter-initial" />
                                                        <label class="custom-control-label" for="filter-initial">Inisial</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['tempat_lahir', 'tanggal_lahir', 'jenis_kelamin', 'agama', 'status_pernikahan']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!--Section 2--> 
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Kontak Pegawai
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['alamat', 'rt_rw', 'kel_kec_kota', 'kode_pos', 'telp_rumah']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.phone" type="checkbox" class="custom-control-input" id="filter-phone" />
                                                        <label class="custom-control-label" for="filter-phone">No. HP</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.email" type="checkbox" class="custom-control-input" id="filter-email" />
                                                        <label class="custom-control-label" for="filter-email">Alamat Email</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['alumnus_bta', 'joined_at_bta']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!--Section 3--> 
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Histori Pendidikan
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['asal_sd', 'lulus_sd', 'asal_smp', 'lulus_smp', 'asal_sma', 'lulus_sma', 'asal_univ', 'fakultas_univ', 'jurusan_univ', 'lulus_univ']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!--Section 4--> 
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Keluarga Pegawai
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['nama_pasangan', 'tempat_lahir_pasangan', 'tanggal_lahir_pasangan', 'jumlah_anak']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <template v-for="n in 5">
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['nama_anak_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-nama_anak_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-nama_anak_' + n">Nama Anak {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['tempat_lahir_anak_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-tempat_lahir_anak_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-tempat_lahir_anak_' + n">Tempat Lahir Anak {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['tanggal_lahir_anak_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-tanggal_lahir_anak_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-tanggal_lahir_anak_' + n">Tanggal Lahir Anak {{ n }}</label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <!--Section 5--> 
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepegawaian
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.branches" type="checkbox" class="custom-control-input" id="filter-branches" />
                                                        <label class="custom-control-label" for="filter-branches">Cabang</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['golongan', 'nomor_ktp']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.identity" disabled type="checkbox" class="custom-control-input" id="filter-identity" />
                                                        <label class="custom-control-label" for="filter-identity">NIP</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['nomor_npwp', 'nomor_rekening', 'bank_rekening', 'nama_rekening']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.roles" type="checkbox" class="custom-control-input" id="filter-roles" />
                                                        <label class="custom-control-label" for="filter-roles">Jabatan</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.subject" type="checkbox" class="custom-control-input" id="filter-subject" />
                                                        <label class="custom-control-label" for="filter-subject">Mata Pelajaran</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-auto">
                                        <h4 class="text-danger p-2 mb-0">Jika Sudah, silakan</h4>
                                    </div>
                                    <div class="col">
                                        <button class="btn btn-danger btn-sm px-5" type="button" v-on:click="filterShow = false">Hide Column Filtering</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col" v-if="columns.identity">
                                    NIP
                                </th>
                                <th scope="col" v-if="columns.name" name="name" style="min-width: 15rem;" v-on:click="sort">
                                    Nama Lengkap <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.username">
                                    Username
                                </th>
                                <th scope="col" v-if="columns.shortname">
                                    Nama Panggilan
                                </th>
                                <th scope="col" v-if="columns.initial">
                                    Inisial
                                </th>
                                <th scope="col" v-if="columns.email">
                                    Email
                                </th>
                                <th scope="col" v-if="columns.phone">
                                    No. HP
                                </th>
                                <th scope="col" v-if="columns.branches">
                                    Cabang
                                </th>
                                <th scope="col" v-if="columns.roles" name="rank" v-on:click="sort">
                                    Jabatan <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.subject">
                                    Mata Pelajaran
                                </th>

                                <th scope="col" v-for="profileLabel in profileLabels" v-if="columns[profileLabel]">
                                    {{ renderProfileLabel(profileLabel) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="employee in employees" v-bind:key="employee.userID">
                                <td v-if="columns.identity">
                                    <router-link v-bind:to="{name: 'employee/view', params: {id: employee.userID}}" class="text-loading" v-if="profile.isAdmin || (profile.isEmployee && ((profile.employee.isDirector || profile.employee.isManager || profile.employee.isCoordinator) || roleElligibleView(employee)))">{{ employee.identity }}</router-link>
                                    <span class="text-loading" v-else>{{ employee.identity }}</span>
                                </td>
                                <td v-if="columns.name">
                                    <span class="text-loading" v-if="employee.user">{{ employee.user.name }}</span>
                                </td>
                                <td v-if="columns.username">
                                    <span class="text-loading" v-if="employee.user">{{ employee.user.username }}</span>
                                </td>
                                <td v-if="columns.shortname">
                                    <span class="text-loading">{{ employee.shortname }}</span>
                                </td>
                                <td v-if="columns.initial">
                                    <span class="text-loading">{{ employee.initial }}</span>
                                </td>
                                <td v-if="columns.email">
                                    <span class="text-loading" v-if="employee.user">{{ renderCheckBlank(employee.user.email) }}</span>
                                </td>
                                <td v-if="columns.phone">
                                    <span class="text-loading">{{ employee.phone }}</span>
                                </td>
                                <td v-if="columns.branches">    
                                    <span v-bind:class="{'text-loading': typeof employee.isBranchStaff === typeof undefined}">{{ listBranches(employee) }}</span>
                                </td>
                                <td v-if="columns.roles">
                                    <span v-bind:class="{'text-loading': typeof employee.isBranchStaff === typeof undefined}">{{ listRoles(employee) }}</span>
                                </td>
                                <td v-if="columns.subject">
                                    <span v-bind:class="{'text-loading': typeof employee.isBranchStaff === typeof undefined}">{{ listSubjects(employee) }}</span>
                                </td>

                                <td v-for="profileLabel in profileLabels" v-if="columns[profileLabel]">
                                    <span v-bind:class="{'text-loading': typeof employee.additionals !== typeof undefined && typeof employee.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(renderProfileLabelValue(employee, profileLabel)) }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
        <b-modal v-model="modalShow" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Data Pegawai
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="upload">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-employee.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Jabatan</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.role" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Jabatan...</option>
                                        <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">{{ role.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file" type="file" class="form-control" v-on:change="fileUpload" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button> 
                                        {{ form.upload.employee.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modalShow = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import Paginate from 'vuejs-paginate';
    import { employeeRoles } from '@/params.js';
    import qs from 'qs';

    export default {
        name: "StudentIndex",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    search: {
                        keyword: '',
                        sortColumn: 'name',
                        sortType: 'asc',
                        branchID: ''
                    },
                    upload: {
                        employee: '',
                        role: ''
                    }
                },
                columns: {
                    username: false, name: true, identity: true, email: true, shortname: true, initial: true, phone: true, roles: true, branches: false, subject: false,

                    golongan: false, nomor_npwp: false, nomor_ktp: false, jenis_kelamin: false, tempat_lahir: false, tanggal_lahir: false, agama: false,
                    bank_rekening: false, nomor_rekening: false, nama_rekening: false,
                    alamat: false, rt_rw: false, kel_kec_kota: false, kode_pos: false, telp_rumah: false,
                    asal_sd: false, lulus_sd: false, asal_smp: false, lulus_smp: false, asal_sma: false, lulus_sma: false, asal_univ: false, fakultas_univ: false, jurusan_univ: false, lulus_univ: false,
                    alumnus_bta: false, joined_at_bta: false,
                    status_pernikahan: false, nama_pasangan: false, tempat_lahir_pasangan: false, tanggal_lahir_pasangan: false, jumlah_anak: false,
                    nama_anak_1: false, tempat_lahir_anak_1: false, tanggal_lahir_anak_1: false,
                    nama_anak_2: false, tempat_lahir_anak_2: false, tanggal_lahir_anak_2: false,
                    nama_anak_3: false, tempat_lahir_anak_3: false, tanggal_lahir_anak_3: false,
                    nama_anak_4: false, tempat_lahir_anak_4: false, tanggal_lahir_anak_4: false,
                    nama_anak_5: false, tempat_lahir_anak_5: false, tanggal_lahir_anak_5: false
                },
                modalShow: false,
                filterShow: false,
                pageCount: 0,
                page: 1,
                branches: [],
                profileLabels: [],
                roles: [],
                employees: [
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}},
                    {user: {}, additionals: {}}
                ]
            };
        },
        methods: {
            upload() {
                var formData = new FormData();
                for (var attribute in this.form.upload) {
                    formData.set(attribute, this.form.upload[attribute]);
                }
                this.axios.post(process.env.API_URL + '/employee/upload', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modalShow = false;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/employee', {params: Object.assign({}, this.form.search, {page: page})}).then(response => {
                    this.employees = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            download() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/employee/download?' + qs.stringify(Object.assign({}, this.form.search, {token: token}), {encode: false});
            },
            fileUpload(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.upload.employee = input.files[0];
                }
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            renderProfileLabelValue(employee, profileLabel) {
                if (typeof employee.additionals !== typeof undefined) {
                    var value = employee.additionals[profileLabel];
                    if (value) {
                        switch (profileLabel) {
                            default:
                                break;
                        }
                    }
                    return value;
                }
                return '';
            },
            renderProfileLabel(profileLabel) {
                switch (profileLabel) {
                    default:
                        break;
                }
                return this.humanize(profileLabel);
            },
            renderCheckBlank(value) {
                return (value !== '' && value !== null) || typeof value === typeof undefined ? value : " ";
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles(employee) {
                var roles = [];
                for (var i in employeeRoles) {
                    if (employee['is' + employeeRoles[i].id]) {
                        roles.push(employeeRoles[i].id);
                    }
                }
                return this.listRelations(this.roles.filter(object => roles.includes(object.id)));
            },
            listSubjects(employee) {
                var subjects = [];
                if (employee.isCoordinator) {
                    subjects.push({name: employee.coordinator.subject.name});
                }
                if (employee.isTeacher) {
                    for (let i = 0; i < employee.teacher.subjects.length; i++) {
                        subjects.push({name: employee.teacher.subjects[i].name});
                    }
                }
                return this.listRelations(subjects.filter((value, index, array) => array.indexOf(value) === index));
            },
            listBranches(employee) {
                var branches = [];
                if (employee.isBranchStaff) {
                    branches.push({name: employee.branchStaff.branch.name});
                }
                if (employee.isMentor) {
                    branches.push({name: employee.mentor.branch.name});
                }
                if (employee.isBranchHead) {
                    branches.push({name: employee.branchHead.branch.name});
                }
                return this.listRelations(branches.filter((value, index, array) => array.indexOf(value) === index));
            },
            sort(event) {
                var column = event.currentTarget;
                var columnName = column.getAttribute("name");
                if (columnName) {
                    this.form.search.sortType = (this.form.search.sortColumn !== columnName || this.form.search.sortType !== 'asc') ? 'asc' : 'desc';
                    this.form.search.sortColumn = columnName;

                    document.querySelectorAll("table tr th[sort]").forEach(element => {
                        element.removeAttribute("sort");
                    });
                    column.setAttribute("sort", this.form.search.sortType);
                }
                this.paginate(1);
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isCoordinator || this.profile.employee.isBranchStaff));
            },
            roleElligibleView(employee) {
                if (this.profile.isEmployee) {
                    switch (true) {
                        case this.profile.employee.isBranchStaff:
                            if (employee.isMentor) {
                                return employee.mentor.branchID === this.profile.employee.branchStaff.branchID;
                            }
                            break;

                        case this.profile.employee.isBranchHead:
                            if (employee.isMentor) {
                                return employee.mentor.branchID === this.profile.employee.branchHead.branchID;
                            } else if (employee.isBranchStaff) {
                                return employee.branchStaff.branchID === this.profile.employee.branchHead.branchID;
                            }
                            break;

                        default:
                            break;
                    }
                }
                return false;
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/branch'),
                this.axios.get(process.env.API_URL + '/employee/listAttributes')
            ]).then(this.axios.spread(function (responseBranch, responseProfileLabel) {
                this.branches = responseBranch.data.data;
                this.profileLabels = responseProfileLabel.data.data;
            }.bind(this)));

            this.roles = employeeRoles;
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'List Employee - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active { transition: opacity .5s; }
    .fade-enter, .fade-leave-to { opacity: 0; }

    @media (min-width: 768px) {
        .table-responsive .table td:first-child, .table-responsive .table th:first-child { min-width: 8.2rem;}
        .table-responsive .table td:nth-child(2), .table-responsive .table th:nth-child(2) { left: 8.2rem; top: auto; position: -webkit-sticky; position: sticky; }
    }
</style>


// WEBPACK FOOTER //
// src/components/employee/Index.vue